// {
//   title: "Junior Product Designer",
//   category: "product",
//   emoji: "🖖",
//   url: "https://linkedin.com/1",
// },
export const jobOffers = [];
